export const X46MK2_INTERIOR_CONFIGURATION_KEYS = [
  'PortAftCabinOptions',
  'StarboardAftCabinOptions',
  'Veneer',
  'Floorboard',
  'Worktop',
  'StarboardAftCabin',
  'FabricSaloon',
  'CupboardsOwnersCabin',
  'Mast',
  'TableBox',
  'Pouffes',
  'FabricCabins'
]

export function normalizeX46MK2InteriorConfiguration (interior) {
  const normalized = {}

  X46MK2_INTERIOR_CONFIGURATION_KEYS.forEach(key => {
    if (interior && interior[key]) {
      normalized[key] = interior[key]
    }
  })

  return normalized
}

/**
 * Maps user-facing exterior values (1–2) to matte/render values.
 * Hidden value 3 is never stored in state or share codes.
 *
 * Rules:
 * 1. CockpitBenchExtentions: 2 + CockpitCushionSeats on (2) → 3 (cushion matte)
 * 2. GTSeat: 2 + CockpitCushionSeats on (2) → 3 (cushion matte)
 * 3. TeakOnCoachRoof: 2 + SelfTacker on (2) → 3 (cutout matte)
 */
export function applyX46MK2RenderDerivations (exterior) {
  const render = { ...exterior }

  if (
    exterior.CockpitCushionSeats &&
    exterior.CockpitCushionSeats.value === 2 &&
    exterior.CockpitBenchExtentions &&
    exterior.CockpitBenchExtentions.value === 2
  ) {
    render.CockpitBenchExtentions = {
      ...exterior.CockpitBenchExtentions,
      value: 3
    }
  }

  if (
    exterior.CockpitCushionSeats &&
    exterior.CockpitCushionSeats.value === 2 &&
    exterior.GTSeat &&
    exterior.GTSeat.value === 2
  ) {
    render.GTSeat = { ...exterior.GTSeat, value: 3 }
  }

  if (
    exterior.TeakOnCoachRoof &&
    exterior.TeakOnCoachRoof.value === 2 &&
    exterior.SelfTacker &&
    exterior.SelfTacker.value === 2
  ) {
    render.TeakOnCoachRoof = { ...exterior.TeakOnCoachRoof, value: 3 }
  }

  return render
}



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2RenderConfiguration.js